
import React from 'react'

class ErrorModal extends React.Component {

  render() {
    let {
      error
    } = this.props
    error = error.toJS()

    return (
      <div className="document-error-item">
        <div className="message">{error.message}</div>
        <div>Line: {error.line}</div>
        <div>Column: {error.column}</div>
        <div>Character: {error.char}</div>
        <div>Position: {error.position}</div>
      </div>
    )
  }
}

export default ErrorModal
